<template>
  <el-button
    size="mini"
    icon="el-icon-document-copy"
    @click="copy"
  >
    {{ label }}
  </el-button>
</template>

<script>
  import { copyText } from '@/utils/clipboard';

  export default {
    name: 'CopyToClipboardButton',
    props: {
      text: { type: String, required: true },
      label: { type: String, required: true },
    },
    methods: {
      async copy() {
        if (await copyText(this.text)) {
          this.$message.success(this.$t('global.clipboard.copied'));
        } else {
          this.$notify({
            showClose: true,
            type: 'error',
            message: this.$t('global.clipboard.copyFailed'),
          });
        }
      },
    },
  };
</script>
